import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[panDirective]'
})
export class PanDirective {
  private isPanning = false;
  private startX = 0;
  private startY = 0;
  private scrollLeft = 0;
  private scrollTop = 0;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    event.preventDefault();
    this.isPanning = true;
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.scrollLeft = this.el.nativeElement.scrollLeft;
    this.scrollTop = this.el.nativeElement.scrollTop;
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grabbing');
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (!this.isPanning) return;

    const deltaX = event.clientX - this.startX;
    const deltaY = event.clientY - this.startY;
    this.el.nativeElement.scrollLeft = this.scrollLeft - deltaX;
    this.el.nativeElement.scrollTop = this.scrollTop - deltaY;
  }

  @HostListener('mouseup')
  @HostListener('mouseleave')
  onMouseUp(): void {
    this.isPanning = false;
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grab');
  }
}
